import { call, put, takeEvery } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import axios from 'axios';
import API from '../../API';



async function postApi(data) {
    const apiUrl = API.baseURL + `/web_provider_notification`;
    try {
        // const response = await fetch(apiUrl, requestOptions);
        const response = axios.get(apiUrl, API.options)
        return await response;
    } catch (error) {
        throw error;
    }
}

function* notifications(action) {
    try {
        const response = yield call(postApi, action.data);
        if (response.status == 200 || response.status == 201) {
            yield put({ type: 'GET_FIRST_FIVE_NOTIFICATIONS_SUCCESS', data: response.data.data.activities });
            // toastr.success('Deleted', 'You are successfully deleted the message');
        } else {
            // response.errors.length != 0 && toastr.error('Deletion Failed', response.errors[0]);
        }
        // history.push('/');

    } catch (e) {
        yield put({ type: 'GET_FIRST_FIVE_NOTIFICATIONS_FAILED', message: e.message });
    }
}

function* firstFiveNotificationsSaga() {
    yield takeEvery('GET_FIRST_FIVE_NOTIFICATIONS_REQUESTED', notifications);
}

export default firstFiveNotificationsSaga;